// Where to land after signing in. Defaults to Home; ?next= lets a page send the reader
// back where they were, which is what closes the loop for a signed-out visitor who
// followed a shared Aftershow link, read the room, and signed in to join it.
//
// STRICTLY a same-origin PATH. An unvalidated next= is an OPEN REDIRECT: location.href
// happily accepts "//evil.com", "https://evil.com" and "\\/evil.com", and a login page
// that forwards to an attacker's domain immediately after authenticating is a credible
// phishing step. So: must begin with exactly one forward slash, and the result is
// re-parsed against our own origin so any smuggled scheme or host is dropped rather
// than trusted.
//
// Lives in lib/, not in Login.jsx, so `npm test` (node --test src/lib/*.test.js) can
// actually cover it — a security check nobody can run is a security check nobody keeps.
export function safeNext(raw, origin) {
  const base = origin || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost')
  if (!raw || typeof raw !== 'string') return '/'
  // Reject protocol-relative ("//host") and backslash variants that browsers normalise
  // to a host, before any parsing gets a chance to be clever about them.
  if (raw[0] !== '/' || raw[1] === '/' || raw[1] === '\\') return '/'
  try {
    const u = new URL(raw, base)
    if (u.origin !== new URL(base).origin) return '/'
    return u.pathname + u.search + u.hash
  } catch {
    return '/'
  }
}
